import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MentorshipDashboardService } from "../_services/mentorship-dashboard.service";
import { Router } from "@angular/router";
import * as moment from "moment";
import { ChartDataSets } from "chart.js";
import { Label } from "ng2-charts";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

declare const $: any;

@Component({
  selector: "app-mentorship-dashboard",
  templateUrl: "./mentorship-dashboard.component.html",
  styleUrls: ["./mentorship-dashboard.component.css"],
})
export class MentorshipDashboardComponent implements OnInit {
  @ViewChild("datePicker", { static: false }) datePicker: ElementRef;
  public barChartExpLegend = true;
  public barChartIndLegend = true;
  public indWiseBarChartPlugins = [];
  public expWiseBarChartPlugins = [];

  counts: any;
  minEndDate: string = "";
  showloding = true;
  lodingImage = false;
  startDate: any = "";
  endDate: any = "";
  dateInvalid: boolean = false;
  today: string = "";
  isSubmitted = false;

  // Experience Wise
  public barChartExpWiseData: ChartDataSets[] = [{ data: [], label: "" }];

  public barChartExpWiseLabels: Label[] = [];
  public barChartExpWiseOptions = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: "y", // This makes the chart horizontal
    scales: {
      x: {
        ticks: {
          beginAtZero: true,
        },
        grid: {
          display: true,
        },
      },
      y: {
        ticks: {
          autoSkip: false,
          minRotation: 0,
          maxRotation: 0,
        },
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      tooltip: {
        enabled: true,
      },
    },
    layout: {
      padding: 10,
    },
    datasets: {
      bar: {
        barThickness: 20,
        categoryPercentage: 1.0,
        barPercentage: 0.5,
      },
    },
  };

  public barChartIndWiseData: ChartDataSets[] = [{ data: [], label: "" }];
  public barChartIndWiseLabels: Label[] = [];
  public barChartIndWiseOptions = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: "y",
    scales: {
      x: {
        ticks: {
          autoSkip: false,
        },
        grid: {
          display: true,
        },
      },
      y: {
        ticks: {
          beginAtZero: true,
        },
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      tooltip: {
        enabled: true,
      },
    },
    layout: {
      padding: 10,
    },
  };

  constructor(
    private service: MentorshipDashboardService,
    private router: Router
  ) {
    const now = new Date();
    this.today = now.toISOString().split("T")[0];
  }

  ngOnInit(): void {
    window.scroll(0, 0);

    this.getIndustryWise();
    this.getExperienceWise();
    this.getMentorshipCounts();
  }

  captureAndSavePdf(): void {
    this.loadShow();

    const element = document.getElementById("captureArea");
    if (!element) {
      this.loadHide();
      return;
    }

    element.style.overflow = "visible";
    element.style.height = "auto";

    html2canvas(element, {
      scale: 2,
      scrollY: 0,
      useCORS: true,
      windowHeight: element.scrollHeight,
    })
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");

        const margin = 10;
        const pageWidth = 210;
        const pageHeight = 320;
        const imgWidth = pageWidth - 2 * margin;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        let heightLeft = imgHeight;
        let position = margin;

        pdf.addImage(imgData, "PNG", margin, position, imgWidth, imgHeight);
        heightLeft -= pageHeight - 2 * margin;

        while (heightLeft > 0) {
          position = margin - (imgHeight - heightLeft);
          pdf.addPage();
          pdf.addImage(imgData, "PNG", margin, position, imgWidth, imgHeight);
          heightLeft -= pageHeight - 2 * margin;
        }

        pdf.save("mentorship-dashboard.pdf");
      })
      .finally(() => {
        this.loadHide();
      });
  }

  getMentorshipCounts() {
    this.loadShow();
    const data = {
      start_date: this.startDate,
      end_date: this.endDate,
    };

    this.service.getCounts(data).subscribe((res: any) => {
      if (res["success"] == true) {
        this.counts = res.data;
        this.loadHide();
      }
    });
  }

  ngAfterViewInit(): void {}

  onSearch() {
    this.isSubmitted = true;
    this.dateInvalid = false;

    if (!this.startDate || !this.endDate) {
      return;
    }

    const start = new Date(this.startDate);
    const end = new Date(this.endDate);

    if (start > end) {
      this.dateInvalid = true;
      return;
    }
    this.getMentorshipCounts();
    this.getIndustryWise();
    this.getExperienceWise();
  }

  blockTyping(event: KeyboardEvent) {
    event.preventDefault();
  }

  onReset() {
    this.isSubmitted = false;
    this.startDate = "";
    this.endDate = "";
    this.getMentorshipCounts();
    this.getIndustryWise();
    this.getExperienceWise();
  }

  getExperienceWise() {
    const colors = ["#f49aa2", "#a8bf8a", "#b4cccf", "#e7cfe8", "#fccd86"];

    const data = {
      start_date: this.startDate,
      end_date: this.endDate,
    };

    this.service.getExperienceWise(data).subscribe((res: any) => {
      if (res["success"] == true) {
        this.barChartExpWiseLabels = res.labels;

        const chart_colors = colors.slice(0, res.data.length);
        this.barChartExpWiseData = [
          {
            data: res.data,
            label: "Experience wise",
            backgroundColor: chart_colors,
            borderColor: "#ffffff",
            hoverBackgroundColor: chart_colors,
            borderWidth: 1,
          },
        ];
      }
    });
  }

  getIndustryWise() {
    const colors = ["#84abc9"];

    const data = {
      start_date: this.startDate,
      end_date: this.endDate,
    };
    this.service.getIndustryWise(data).subscribe((res: any) => {
      if (res["success"] == true) {
        this.barChartIndWiseLabels = res.labels;

        const repeatedColors = res.data.map(
          (_, i) => colors[i % colors.length]
        );

        this.barChartIndWiseData = [
          {
            data: res.data,
            label: "Industry wise",
            backgroundColor: repeatedColors,
            borderColor: repeatedColors,
            hoverBackgroundColor: repeatedColors,
          },
        ];
      }
    });
  }

  goToMentorList(status: any) {
    const start = new Date(this.startDate);
    const end = new Date(this.endDate);

    if (start > end) {
      this.isSubmitted = true;
      window.scroll(0, 0);
      this.dateInvalid = true;
      return;
    }
    sessionStorage.setItem("mentorStatus", status);
    sessionStorage.setItem("startDate", this.startDate);
    sessionStorage.setItem("endDate", this.endDate);

    if (status == "approved_mentor") {
      window.open("/mentorship-approved-mentors", "_blank");
    } else if (status == "pending_mentor") {
      window.open("/mentorship-pending-mentors", "_blank");
    } else if (status == "rejected_mentor") {
      window.open("/mentorship-rejected-mentors", "_blank");
    } else {
      window.open("/mentorship-all-mentors", "_blank");
    }
  }

  goToAnotherComp(route: any) {
    const start = new Date(this.startDate);
    const end = new Date(this.endDate);

    if (start > end) {
      this.isSubmitted = true;
      window.scroll(0, 0);
      this.dateInvalid = true;
      return;
    }
    sessionStorage.setItem("startDate", this.startDate);
    sessionStorage.setItem("endDate", this.endDate);
    const url = `/${route}`;
    window.open(url, "_blank");
  }

  getCountByType(type: any): any {
    if (!type || !this.counts) return 0;
    const item = this.counts.find((i) => i.type === type);
    return item ? item.count || item.data || 0 : 0;
  }

  onStartDateChange(selectedDate: string): void {
    this.startDate = selectedDate;
    this.minEndDate = selectedDate;
    if (this.endDate && this.endDate < this.startDate) {
      this.endDate = "";
    }
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }
}
